import { render, staticRenderFns } from "./FlipCountUp.vue?vue&type=template&id=739a0baa&lang=pug"
import script from "./FlipCountUp.vue?vue&type=script&lang=ts"
export * from "./FlipCountUp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports